<template>
  <div style="margin: 25px -20px;">
    <div v-if="debug_show_page_name==true" style="color:green;">certificate</div>
    <div class="row" style="margin-bottom: 10px">
        <div class="col-xs-12" style="padding: 0px;    margin: 0px 5px;">
          <h3>証書情報</h3>
        </div>
        <div class="col-xs-12" style="margin: 0px -10px;">
          <button class="btn btn-primary" 
          :disabled="disableShowSelectCertificate"
          @click="showSelectCertificate">登録済みの証書情報に紐付ける</button>
        </div>
    </div>
    <div class="row " style="margin-top: 10px;">
      <div class=" col-xs-6" style="">
        <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
        <div class="row">
          <div class="col-xs-4"></div>
          <div class="col-xs-8">
            <button class="btn btn-success"
            :disabled="disablePDFbtn || localDisablePDF"
            style="
             float:left;
              min-width: 100px;
              width: 7%;
              margin-right: 10px;
              background: #92d050;
              border-color: #92d050;
            "
            @click="openFileModal"
            >PDF</button>
            <div
              style="width:250px;float:left;margin-top: 3px;">
              <label class="ccontrol-label esma_form_label" style="width:170px;float:left;">添付ファイルの有無</label>
              <div
                v-html="(hasPdfs)?'有り':'無し'"
                style="width: 63px;float: left;border: 2px gray solid;margin-top: 1px;border-radius: 6px;height: 24px;text-align: center;margin-left: 9px;"
                ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-6" style="">
        <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
      </div>
 </div>
    <certificate-list-modal  v-if="disableShowSelectCertificate == false" tag="showcertificateListModal" @selected="oncertificateListModalSelected"></certificate-list-modal>
    <confirmation-modal tag="showConfimationModalCertificateSelected" @done="showConfimationModalCertificateSelectedConfirmed"></confirmation-modal>
    <file-modal tag="showFileModal" @close="pdfClosed"/>
  </div>
</template>

<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_certificate";
import { utils } from "@/libs/utils";
import fieldBoxes from '@/components/form-field';
import informationModal from '@/components/modals/information-modal';
import fileModal from "@/components/modals/file-modal";
import certificateListModal from '@/components/modals/certificate-list-modal';

import constants from '@/rules/constants';

import _debug from "debug";
var mdebug = _debug("esma:certificate");
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    'field-box': fieldBoxes,
    "information-modal":informationModal,
    "certificate-list-modal":certificateListModal,
    "file-modal": fileModal
  },
  data() {
    return {
      api_name: "certificate",
      page_acl: acl.certificate,
      detail_page_url: "/certificate_information_linked_devices/list/",
      state_current_editing:"current_editing2",
      state_current_row:"current_row2",
      state_is_editing_new:"is_editing_new2",
      state_last_filter_options:"last_filter_options2",
      local_fk_id:-1,
      temp_certificate_management_number:"",
      last_selected_row :{},
      _temp:false,
      has_pdfs :false,
      show_has_pdfs :false,
      disable_edit:false,
      fields_validation_is_disabled:false
    };
  },
  computed: {
    DisabledEdit:{
      get(){
        return this.disable_edit;
      },
      set(v){
        this.disable_edit = v;
      }
    },
    localDisablePDF(){
      return typeof this.certificateSeqId == "undefined" || this.certificateSeqId ==  Number.MAX_SAFE_INTEGER;
    },
    hasPdfs:{
      get(){
        return this.has_pdfs;
      },
      set(v){
        this.has_pdfs = v;
      }
    },
    showHasPdfs:{
      get(){
        return this.show_has_pdfs;
      },
      set(v){
        this.show_has_pdfs = v;
      }
    },
    disableShowSelectCertificate(){
      if(this.readOnly == true){
        return true;
      }
      var e = this.$store.state[this.stateCurrentEditing];
      var r = this.$store.state[this.stateCurrentRow];
      var a = ( typeof e["certificate_management_number"]  != "undefined" && e["certificate_management_number"] != "")
      var b = (typeof r["certificate_management_number"]  != "undefined" && r["certificate_management_number"] != "")
      var ret = a || b
      return ret;
    },
    temp:{
      get(){
        return this._temp;
      },
      set(v){
        this._temp = v;
      }
    },
    disableAllBtn(){
      return this.$props.disable_all_btn
    },
    disablePDFbtn(){
        return this.$props.disable_pdf_btn;
    },
    readOnly:{
      get(){
        return this.read_only;
      },
      set(v){
        this.read_only = v;
      }
    },
    fieldList() {
      return fields;
    },
    allFields() {
      return [
        this.local_extend(fields.certificate_management_number, {}),
        this.local_extend(fields.license_certificate_type, {}),
        this.local_extend(fields.certificate_individual_number, {}),
        this.local_extend(fields.sales_company, {}),
        this.local_extend(fields.remark, {})
      ];
    },
    values() {
      console.log("values");
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    formFields() {
      return {
        col1:[
          this.local_extend(fields.certificate_management_number, {disabled: true,read_only: true,}),
          this.local_extend(fields.license_certificate_type, {disabled:this.DisabledEdit,read_only:this.DisabledEdit}),
          this.local_extend(fields.certificate_individual_number, {disabled:this.DisabledEdit,read_only:this.DisabledEdit}),
        ],
        col2:[
          this.local_extend(fields.sales_company, {disabled:this.DisabledEdit,read_only:this.DisabledEdit}),
          this.local_extend(fields.remark, {label_length_4:true}),
        ]
      }
    },
    certificateSeqId() {
      return parseInt(
        this.$store.state[this.stateCurrentRow]["seq_id"] || this.localSeqId
      );
    },
  },
  methods: {
    disableValidation(mode){
      this.formFields.col1.forEach(e =>{
          e.ref_field.disabledIsRequired = mode;
          e.ref_field.localRefreshSequecnce++;
      })
      this.formFields.col2.forEach(e =>{
          e.ref_field.disabledIsRequired = mode;
          e.ref_field.localRefreshSequecnce++;
      })
      this.fields_validation_is_disabled = mode;
    },
    pdfClosed(obj){
      this.showHasPdfs = true;
      this.hasPdfs = parseInt(obj.qty) > 0;
    },
    openFileModal() {
      bus.$emit("showFileModal", { fk_id: this.certificateSeqId });
    },
    showSelectCertificate(){
      return bus.$emit("showcertificateListModal");
    },
    oncertificateListModalSelected(val, row){
      if(val && val.length > 0 ){
        var msg = "管理番号 '"+val+"' を割り当てます。よろしいですか？";
        this.temp_certificate_management_data = false;
          bus.$emit("showConfimationModalCertificateSelected", {
                title:"",
                message:msg,
                yes_label:"OK",
                no_label:"戻る",
                yes_color:"primary",
                model_height:80
              })
        this.temp_certificate_management_number = val;
        this.last_selected_row = row || null;
      }
    },
    checkPDFs(seq_id){
      this.showHasPdfs = false;
      if(isNaN(seq_id) == false ){
        this.$ajax.post('/file_upload/pdf_count/' + seq_id, {}, (err, result) => {
          this.showHasPdfs = true;
          this.hasPdfs = result && parseInt(result.qty) > 0;
        })
      }
    },
    showConfimationModalCertificateSelectedConfirmed(mode){
     if(mode == "yes"){
        this.$store.state[this.stateCurrentRow]["seq_id"] = this.last_selected_row["seq_id"];
        this.$store.state[this.stateCurrentEditing]["seq_id"] = this.last_selected_row["seq_id"];
        this.allFields.forEach(f =>{
          if(f.ref_field){
            this.$store.state[this.stateCurrentRow][f.id] = this.last_selected_row[f.id];
              this.$store.state[this.stateCurrentEditing][f.id] = this.last_selected_row[f.id];
            f.ref_field.updateValue(this.last_selected_row[f.id])
            f.ref_field.local_refresh_sequecnce++;
          }
        })
        if(this.last_selected_row && this.last_selected_row.seq_id){
          this.checkPDFs(this.last_selected_row.seq_id)
        }
      }else if(mode == "no"){
          return bus.$emit("showcertificateListModal");
      }
    },
    local_extend(field_info,ext){
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      return utils.extend(field_info,ext)
    },
    loadRecord(seq_id,cb=()=>{}){
      if(seq_id == "new"){
        this.local_seq_id = Number.MAX_SAFE_INTEGER;
        this.$store.state[this.stateCurrentRow] = {
          seq_id : this.local_seq_id
        }
        this.allFields.forEach(f =>{
          this.$store.state[this.stateCurrentRow][f.id] = "";
        })
        setTimeout(() => {
          this.$store.state[this.stateIsEditingNew] = true;
          // this.read_only = false;
          this.is_new = true;
        }, 300);
        return cb(null,{})
      } else {
        this.is_new = false;
        this.local_seq_id = seq_id;
        if(typeof this.local_seq_id == "undefined"){
          console.error('UNEXPECTED REQUEST TO URL: ','/' + this.api_name + '/get/' + this.local_seq_id);
        }
        this.$ajax.post('/' + this.api_name + '/get/' + this.local_seq_id, {}, (err, result) => {
          if(err){
            this.$notify({
              title: 'データの読込に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }else if( this.isObject(result) == false){
            this.$notify({
              title: 'データの読込に失敗しました。',
              text: "Returned empty data", // KONUMA-SAN PLEASE TRANSLATE HERE [1622873812]: 
              type: 'error',
              duration: 10000
            });
          }
          this.$store.state[this.stateCurrentRow] = result.data;
          this.commonSetStyleForChangedFields(result.data);
          if(result.data || isNaN(result.data.file_upload_qty) == false){
            this.showHasPdfs = true;
            this.hasPdfs = parseInt(result.data.file_upload_qty) > 0;
          }else{
            this.showHasPdfs = false;
             this.$notify({
              title: 'データの読込に失敗しました。',
              text: "Could not count the PDFs", // KONUMA-SAN PLEASE TRANSLATE HERE [1622873808]: 
              type: 'error',
              duration: 10000
            });
          }
          return cb(err,result)
        })
      }
    },
    onLoadData(seq_id){
      this.loadRecord(seq_id)
    },
    onEdit(){
      // this.is_new  = false;
      setTimeout(() => {
        this.readOnly = false;
      }, 300);
    },
    onSave(cb){
      this.commonValidateFields(this, {}, (error_found) => {
        if (error_found != false) {
          return;
        }
        if (this.is_new == false) {
          this.saveEditClicked = true;
        }
        this.commonSaveInfo(this,this.api_name, {ignore_empty_changes:true}, (err,data)=>{
          this.cancelCurrentSelection();
          if(cb){
            return cb(err,data)
          }
        });
      });
    },
    onCancel(){
      this.commonValidateFieldsClear(this,()=>{})
      this.cancelCurrentSelection(true);
    }
  },
  mounted() {
    this.DisabledEdit = this.isApproverUserId == true;
    if(this.$props.controller){
      this.$props.controller.edit = this.onEdit
      this.$props.controller.save = this.onSave
      this.$props.controller.cancel = this.onCancel
      this.$props.controller.load_data = this.onLoadData
      this.$props.controller.disableValidation = this.disableValidation
    }
    if(this.$route.params.seq_id == "new" || this.$route.meta.load_by == "clone"){
      this.commonLoadRecord({force_seq_id:"new"},(err,result)=>{
        this.commonEditDeleteCmdHandler(this);
      })
    }
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
  },
  props: ["controller","disable_pdf_btn"]
};
</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// certificate.vue?30ab8721